import { render, staticRenderFns } from "./ProductSetting.vue?vue&type=template&id=20a53888&scoped=true"
import script from "./ProductSetting.vue?vue&type=script&lang=js"
export * from "./ProductSetting.vue?vue&type=script&lang=js"
import style0 from "./ProductSetting.vue?vue&type=style&index=0&id=20a53888&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a53888",
  null
  
)

export default component.exports